"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OccasionLocalizedReferenceSchema = void 0;
exports.OccasionLocalizedReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/localized/content/occasions.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "OccasionLocalizedReference",
    "description": "Occasions describe the different situations in which consuming the product will give users wings.",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:content:occasions"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2NjYXNpb25zLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9tb2R1bGVzL3JlZmVyZW5jZS9sb2NhbGl6ZWQvY29udGVudC9vY2Nhc2lvbnMuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsZ0NBQWdDLEdBQUc7SUFDOUMsS0FBSyxFQUFFLG1GQUFtRjtJQUMxRixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSw0QkFBNEI7SUFDckMsYUFBYSxFQUFFLG1HQUFtRztJQUNsSCxNQUFNLEVBQUUsUUFBUTtJQUNoQixVQUFVLEVBQUU7UUFDVixNQUFNO1FBQ04sSUFBSTtLQUNMO0lBQ0QsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFO2dCQUNOLHVCQUF1QjthQUN4QjtZQUNELE1BQU0sRUFBRSxRQUFRO1NBQ2pCO1FBQ0QsSUFBSSxFQUFFO1lBQ0osTUFBTSxFQUFFLFFBQVE7WUFDaEIsU0FBUyxFQUFFLGlHQUFpRztTQUM3RztLQUNGO0NBQ0YsQ0FBQSJ9